import { render } from "./add-affect-equipment.vue?vue&type=template&id=3ae97fb8&scoped=true"
import script from "./add-affect-equipment.vue?vue&type=script&lang=js"
export * from "./add-affect-equipment.vue?vue&type=script&lang=js"

import "./add-affect-equipment.vue?vue&type=style&index=0&id=3ae97fb8&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae97fb8"]])

export default __exports__